export function mapReduce(keys, mapping) {
    var oo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return keys.reduce(function(oo, key) {
        oo[key] = mapping(key);
        return oo;
    }, oo);
}
